module.exports = __webpack_public_path__ + "static/media/Online_life_is_real_life_Parents.9f89e10d.pdf";